import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { setAuthorization } from "../../helpers/api_backend_helper";
import { setAuthorization as setAuthAuthorization } from "../../helpers/api_auth_helper"
import { useDispatch, useSelector } from "react-redux";
import { getToken, getUserInfo } from "../../slices/thunks";
import { createSelector } from "reselect";


const AuthCallback = () => {
  const tenantId = useSelector((state) => state.Context.tenantId);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);


  const dispatch = useDispatch();

  const tokenData = createSelector(
    (state) => state.Token,
    (token) => token.token
  );

  const token = useSelector(tokenData);

  useEffect(() => {
    const code = searchParams.get("code");
    const state = searchParams.get("state");

    // Verifica que los parámetros 'code' y 'state' existan en la URL
    if (!token) {
      if (code && state) {
        dispatch(getToken({ tenantId: tenantId, code, state }));
      } else {
        setError("Faltan los parámetros 'code' o 'state' en la URL de callback.");
        setLoading(false);
      }
    } else { // ya tiene token, entonces obtener el userinfo y redirigir
      setAuthorization(token);
      setAuthAuthorization(token);
      dispatch(getUserInfo({ tenantId: tenantId }))

      navigate("/dashboard");
      setLoading(false);
      //}, [searchParams, navigate]);
    }
  }, [token]);

  if (loading) {
    return <div>Procesando autenticación...</div>;
  }

  if (error) {
    return <div>Error de autenticación: {error}</div>;
  }

  return null; // No es necesario renderizar nada mientras se redirige
};

export default AuthCallback;
